//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[[0,"Day",1,0],[0,"Month",1,0],[0,"Time",1,0],[0,"Year",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.DateItemBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DateItemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DateItemBuilder.DayOfMonth = Object.freeze({
    "Day01" : "Day01", "Day02" : "Day02", "Day03" : "Day03", "Day04" : "Day04", "Day05" : "Day05", "Day06" : "Day06", "Day07" : "Day07", "Day08" : "Day08", "Day09" : "Day09", "Day10" : "Day10", "Day11" : "Day11", "Day12" : "Day12", "Day13" : "Day13", "Day14" : "Day14", "Day15" : "Day15", "Day16" : "Day16", "Day17" : "Day17", "Day18" : "Day18", "Day19" : "Day19", "Day20" : "Day20", "Day21" : "Day21", "Day22" : "Day22", "Day23" : "Day23", "Day24" : "Day24", "Day25" : "Day25", "Day26" : "Day26", "Day27" : "Day27", "Day28" : "Day28", "Day29" : "Day29", "Day30" : "Day30", "Day31" : "Day31", "Blank" : "Blank"});

SPLM.DateItemBuilder.MonthOfYear = Object.freeze({
    "Jan" : "Jan", "Feb" : "Feb", "Mar" : "Mar", "Apr" : "Apr", "May" : "May", "Jun" : "Jun", "Jul" : "Jul", "Aug" : "Aug", "Sep" : "Sep", "Oct" : "Oct", "Nov" : "Nov", "Dec" : "Dec", "Blank" : "Blank"});

export default SPLM;